const charData: any = [
  {
    title: "Pablo Emilio",
    subtitle: "Escobar",
    info: "Pablo Emilio Escobar Gaviria was a Colombian drug lord and narcoterrorist who was the founder and sole leader of the Medellín Cartel...",
  },
  {
    title: "Joaquín Archivaldo",
    subtitle: "Steve",
    info: "Joaquín Archivaldo Guzmán Loera born 4 April 1957 commonly known as 'El Chapo' because of his 168 cm (5 ft 6 in) stature, is a Mexican former drug lord and a former leader within the Sinaloa Cartel, an international crime syndicate. ",
  },
  {
    title: "Pablo Emilio",
    subtitle: "Jav",
    info: "Pablo Emilio Escobar Gaviria was a Colombian drug lord and narcoterrorist who was the founder and sole leader of the Medellín Cartel...",
  },
  {
    title: "Joaquín Archivaldo",
    subtitle: "El Chapo",
    info: "Joaquín Archivaldo Guzmán Loera born 4 April 1957 commonly known as 'El Chapo' because of his 168 cm (5 ft 6 in) stature, is a Mexican former drug lord and a former leader within the Sinaloa Cartel, an international crime syndicate. ",
  },
];

export default charData;
